import { Box, Typography } from "@mui/material";

import { SalePhase, useCountdown } from "../helpers";
import styles from "./styles";

interface Props {
  phase: SalePhase;
  countdownTarget: Date;
}

const pad = (n: number) => String(n).padStart(2, "0");

const Hero = ({ phase, countdownTarget }: Props) => {
  const { days, hrs, mins, secs } = useCountdown(countdownTarget);
  const isEnded = phase === "ended";
  const countdownLabel = phase === "pre" ? "Sale opens in" : "Sale ends in";

  const units = [
    { label: "Days", value: String(days) },
    { label: "Hrs", value: pad(hrs) },
    { label: "Min", value: pad(mins) },
    { label: "Sec", value: pad(secs) },
  ];

  return (
    <Box sx={styles.hero}>
      <Typography sx={styles.eyebrow}>
        Limited-time offer · June 29–July 6
      </Typography>
      <Typography component="h1" sx={styles.title}>
        Buy 2 Months — Get 1 Free
      </Typography>
      <Typography sx={styles.subtitle}>
        Land more brand deals for two-thirds the price — your third month on any
        Bento plan is on us.
      </Typography>

      {isEnded ? (
        <Box sx={styles.closedPill}>🔒 This offer closed on July 6, 2026</Box>
      ) : (
        <>
          <Typography sx={styles.countdownLabel}>{countdownLabel}</Typography>
          <Box sx={styles.countdownRow}>
            {units.map((unit) => (
              <Box key={unit.label} sx={styles.countdownBox}>
                <Typography sx={styles.countdownValue}>{unit.value}</Typography>
                <Typography sx={styles.countdownUnit}>{unit.label}</Typography>
              </Box>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default Hero;
